import { render, staticRenderFns } from "./performancePersonConfigComponent.vue?vue&type=template&id=300cc0c6&scoped=true&"
import script from "./performancePersonConfigComponent.vue?vue&type=script&lang=js&"
export * from "./performancePersonConfigComponent.vue?vue&type=script&lang=js&"
import style0 from "./performancePersonConfigComponent.vue?vue&type=style&index=0&id=300cc0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300cc0c6",
  null
  
)

export default component.exports